import Odoo_softwaretool from "../../../Assets/Oddo_ErpSystem.png";
import HeaderSectionReusableComponent from "../../component/ReusablaeComponent/HeaderSectionReusableComponent";
import Image_ContentReusableComponent from "../../component/ReusablaeComponent/Image_ContentReusableComponent";
import HeadingParagraphSection from "../../component/ReusablaeComponent/HeadingParagraphSection";
import LifeSciences from '../../../Assets/science1.png';
import ClinicalTrails from '../../../Assets/science2.jpg';
import lifesciencemethod from '../../../Assets/sience3.jpg';
import digital_health from '../../../Assets/science4.jpg'
import ScienceImage from '../../../Assets/science5.jpg';
import { Helmet } from 'react-helmet';

const LifeScience = () => {
  return (
    <div>
      <Helmet>
        <title>PT KCS | Life Sciences Industry ERP Solutions & Compliance Indonesia – Jakarta</title>
        <meta 
          name="description" 
          content="PT KCS provides specialized ERP solutions for Indonesia's life sciences sector. Ensure BPOM, FDA, and EMA regulatory compliance, quality control, and clinical trial management across Jakarta and beyond." 
        />
        <meta 
          name="keywords" 
          content="PT KCS, PT KCS Indonesia, life sciences ERP Jakarta, Infor LN life sciences, Infor M3 pharma, Infor Syteline life sciences, pharmaceutical ERP Indonesia, software farmasi Indonesia, BPOM compliance software, FDA EMA regulatory compliance IT, clinical trials data management Indonesia, personalized medicine technology, life sciences supply chain optimization, data integrity security software, medical device manufacturing ERP, biotech IT solutions Indonesia, laboratory information management system LIMS, GxP compliance software, validation services life sciences, pharma manufacturing execution system MES, drug discovery software Indonesia, health tech solutions Jakarta, healthcare supply chain ERP, medical distribution software, biotech research IT, life sciences digital transformation, Industry 4.0 pharma Indonesia, serialization software pharma, track and trace pharmaceuticals, lab automation software" 
        />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS" />
      </Helmet>


      <HeaderSectionReusableComponent
        mainHeading="Streamlining Regulatory Submissions"
        paragragh={
          <>
            Regulatory approval is one of the biggest challenges in the life sciences sector. Our solutions simplify the preparation and submission of documentation, reducing errors and ensuring faster approvals. By maintaining accurate, real-time data across departments, organizations can confidently meet the requirements of FDA, EMA, and other global authorities.
          </>
        }
        imgScr={LifeSciences}
      
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        heading="Ensuring Patient Safety at Every Stage"
        paragraph={
          <>
            Patient safety is at the heart of life sciences. Our platforms provide end-to-end visibility, ensuring that every ingredient, process, and product meets the highest safety standards. With automated checks, traceability, and robust reporting, we help minimize risks and strengthen confidence in the products reaching patients.
          </>
        }
        imgsrc={ClinicalTrails}
      />
      <HeadingParagraphSection
        heading="Driving Efficiency in Clinical Trials"
        paragraph={
          <>
            Clinical trials demand meticulous planning, data handling, and compliance. Our services help streamline trial management by integrating patient data, site information, and research results in a single, secure environment. This reduces delays, enhances accuracy, and ensures trials progress smoothly—accelerating the journey from lab to patient.
          </>
        }
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        reverse={false}
        heading="Strengthening Data Integrity and Security"
        paragraph={
          <>
            In an industry where data is both sensitive and mission-critical, protecting it is non-negotiable. Our solutions provide secure, compliant systems that safeguard information while making it easily accessible to authorized teams. With built-in controls, audit trails, and advanced security features, we ensure data integrity and trust across the enterprise.
          </>
        }
        imgsrc={lifesciencemethod}
      />
      <Image_ContentReusableComponent
        heading="Supporting Personalized Medicine and Innovation"
        paragraph={
          <>
           <p> Life sciences is moving toward personalized treatments tailored to individuals. Our technologies empower researchers and manufacturers with the insights and tools they need to make this possible. By harnessing advanced analytics, companies can design therapies that are not only effective but also customized to improve patient outcomes on a global scale.
            </p>
          </>
        }
        imgsrc={digital_health}
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        reverse={false}
        heading="Unlocking Global Growth Opportunities"
        paragraph={
          <>
            Scaling operations in life sciences requires flexibility and compliance with diverse international standards. Our solutions are built to support global expansion—helping companies manage multi-country operations, varied regulations, and cross-border supply chains. This allows organizations to confidently enter new markets and bring innovations to more patients worldwide.
          </>
        }
        imgsrc={ScienceImage}
      />
    </div>
  );
};

export default LifeScience;
